import { render } from "./BankInfoBox.vue?vue&type=template&id=16522916&scoped=true"
import script from "./BankInfoBox.vue?vue&type=script&lang=js"
export * from "./BankInfoBox.vue?vue&type=script&lang=js"

import "./BankInfoBox.vue?vue&type=style&index=0&id=16522916&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16522916"]])

export default __exports__